import type {MotionProps} from '../types';
import {RECIPES, type RecipeName} from './recipeMap';

export type {RecipeName} from './recipeMap';

function isRecord(value: unknown): value is Record<string, unknown> {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
}

function deepMerge(
  left: Record<string, unknown>,
  right: Record<string, unknown>,
): Record<string, unknown> {
  const result: Record<string, unknown> = {...left};
  for (const [key, rightValue] of Object.entries(right)) {
    const leftValue = result[key];
    if (isRecord(leftValue) && isRecord(rightValue)) {
      result[key] = deepMerge(leftValue, rightValue);
    } else {
      result[key] = rightValue;
    }
  }
  return result;
}

export const isMotionProps = (arg: unknown): arg is MotionProps =>
  typeof arg === 'object' && arg !== null;

export const isRecipeName = (arg: unknown): arg is RecipeName =>
  typeof arg === 'string' && arg in RECIPES;

export function mergeMotionArgs<R extends Record<string, MotionProps>>(
  args: Array<Extract<keyof R, string> | MotionProps>,
  recipes: R,
): MotionProps {
  let merged: MotionProps = {};
  for (const arg of args) {
    const animationConfig = typeof arg === 'string' ? recipes[arg] ?? {} : arg;
    merged = deepMerge(merged, animationConfig) as MotionProps;
  }
  return merged;
}
